import { userSchema } from "../auth/types.js";
import { ticketSchema } from "../tickets/types.js";
import { z } from "zod";
export const contactSchema = z.object({
    GSI1_PK: z.string(),
    GSI1_SK: z.string(),
    GSI2_PK: z.string(),
    GSI2_SK: z.string(),
    PK: z.string(),
    SK: z.string(),
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    mobile: z.string(),
    emailAddress: z.string(),
    emailOptIn: z.boolean(),
    smsOptIn: z.boolean(),
    title: z.string().optional(),
    user: userSchema.optional(),
    tickets: z.array(ticketSchema),
});
// export type Contact = {
//   GSI1_PK: string;
//   GSI1_SK: string;
//   GSI2_PK: string;
//   GSI2_SK: string;
//   PK: string;
//   SK: string;
//   id: string;
//   firstName: string;
//   lastName: string;
//   mobile: string;
//   emailAddress: string;
//   emailOptIn: boolean;
//   smsOptIn: boolean;
//   title?: string;
//   user?: User;
//   tickets: Array<Ticket>;
// };
//# sourceMappingURL=types.js.map